import React from 'react';
import { useHaptic } from '../../hooks';
import './ios-components.css';

/**
 * Button estilo iOS
 * Variantes: default, primary, destructive, ghost
 * Tamanhos: small, medium, large
 */
function IOSButton({
  children,
  variant = 'default',
  size = 'medium',
  onClick,
  disabled = false,
  type = 'button',
  fullWidth = false,
  icon: Icon,
  haptic = true,
  ...props
}) {
  const { light } = useHaptic();

  const handleClick = (e) => {
    if (haptic && !disabled) {
      light();
    }
    onClick?.(e);
  };

  return (
    <button
      type={type}
      className={`
        ios-button
        ios-button--${variant}
        ios-button--${size}
        ${fullWidth ? 'ios-button--full-width' : ''}
        ${disabled ? 'ios-button--disabled' : ''}
      `}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {Icon && (
        <span className="ios-button__icon">
          <Icon size={size === 'small' ? 16 : size === 'large' ? 24 : 20} />
        </span>
      )}
      <span className="ios-button__text">{children}</span>
    </button>
  );
}

export default IOSButton;
